var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { Screen } from '@reference-data/screen.enum';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import steem from 'steem';
import hive from '@hiveio/hive-js';
import blurt from '@blurtfoundation/blurtjs';
const DEFAULT_CONFIG = {
    steem_api: "https://api.steemit.com",
    hive_api: "https://api.openhive.network",
    blurt_api: "https://rpc.blurt.blog",
    steem_color: "#90ee90",
    hive_color: "#ffff00",
    blurt_color: "#FF6600"
};
let configPromise = null;
export const getDefVal = (key) => __awaiter(void 0, void 0, void 0, function* () {
    let keyl = key.toLowerCase();
    if (!configPromise) {
        configPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                const response = yield fetch('https://timeapp.foundation/defval.php', {
                    method: 'GET',
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = yield response.json();
                if (json.ok && json.data)
                    return json.data;
            }
            catch (error) {
                console.warn('⚠️ Server unreachable, using defaults:', error);
            }
            return DEFAULT_CONFIG;
        }))();
    }
    const config = yield configPromise;
    return config[keyl] || DEFAULT_CONFIG[keyl] || '';
});
const TopBar = ({ activeAccount, accounts, navigateTo, addToLoadingList, removeFromLoadingList, setErrorMessage, setSuccessMessage, onRefresh, }) => {
    const [currentChain, setCurrentChain] = useState('STEEM');
    const [hasReward, setHasReward] = useState(false);
    const [rotateLogo, setRotateLogo] = useState(false);
    const [claimAllUsers, setClaimAllUsers] = useState(false);
    const [claimAllChains, setClaimAllChains] = useState(false);
    // === BULK CLAIM STATES ===
    const [showBulkClaimModal, setShowBulkClaimModal] = useState(false);
    const [bulkClaimItems, setBulkClaimItems] = useState([]);
    const [isBulkClaiming, setIsBulkClaiming] = useState(false);
    const stopFlagRef = useRef(false);
    const [canClaim, setCanClaim] = useState(false);
    useEffect(() => {
        const loadChain = () => __awaiter(void 0, void 0, void 0, function* () {
            const saved = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
            const chain = (saved ? String(saved) : 'STEEM').replace(/"/g, '').toUpperCase();
            setCurrentChain(chain);
        });
        loadChain();
        const interval = setInterval(loadChain, 1000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        const checkCurrentClaimable = () => __awaiter(void 0, void 0, void 0, function* () {
            if (claimAllUsers || claimAllChains) {
                setCanClaim(true);
                return;
            }
            if (!(activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name)) {
                setCanClaim(false);
                return;
            }
            try {
                const rpcUrl = yield getDefVal(`${currentChain.toLowerCase()}_api`);
                let client = currentChain === 'HIVE' ? hive : currentChain === 'BLURT' ? blurt : steem;
                client.api.setOptions({ url: rpcUrl });
                const [accs] = yield Promise.all([client.api.getAccountsAsync([activeAccount.name])]);
                if (!accs || !accs[0]) {
                    setCanClaim(false);
                    return;
                }
                const acc = accs[0];
                let hasClaim = false;
                if (currentChain === 'STEEM') {
                    hasClaim = parseFloat(acc.reward_steem_balance || 0) > 0 ||
                        parseFloat(acc.reward_sbd_balance || 0) > 0 ||
                        parseFloat(acc.reward_vesting_balance || 0) > 0;
                }
                else if (currentChain === 'HIVE') {
                    hasClaim = parseFloat(acc.reward_hive_balance || 0) > 0 ||
                        parseFloat(acc.reward_hbd_balance || 0) > 0 ||
                        parseFloat(acc.reward_vesting_balance || 0) > 0;
                }
                else if (currentChain === 'BLURT') {
                    hasClaim = parseFloat(acc.reward_blurt_balance || 0) > 0 ||
                        parseFloat(acc.reward_vesting_balance || 0) > 0;
                }
                setCanClaim(hasClaim);
            }
            catch (e) {
                console.error('Error checking claimable:', e);
                setCanClaim(false);
            }
        });
        checkCurrentClaimable();
        const interval = setInterval(checkCurrentClaimable, 60000);
        return () => clearInterval(interval);
    }, [activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name, currentChain, claimAllUsers, claimAllChains]);
    const refresh = () => {
        setRotateLogo(true);
        onRefresh();
        setTimeout(() => setRotateLogo(false), 1000);
    };
    // ====================== CLAIM ======================
    const claimReward = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const isSingleUser = !claimAllUsers;
        const isSingleChain = !claimAllChains;
        stopFlagRef.current = false;
        setShowBulkClaimModal(true);
        setBulkClaimItems([]);
        setIsBulkClaiming(true);
        const usersToProcess = isSingleUser && (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name)
            ? [activeAccount]
            : (accounts || []).filter(a => a.name);
        const chainsToProcess = isSingleChain ? [currentChain] : ['STEEM', 'HIVE', 'BLURT'];
        for (const account of usersToProcess) {
            if (stopFlagRef.current)
                break;
            const username = account.name;
            for (const chain of chainsToProcess) {
                if (stopFlagRef.current)
                    break;
                const item = {
                    chain,
                    username,
                    status: 'checking',
                    claimable: false
                };
                setBulkClaimItems(prev => [...prev, item]);
                yield new Promise(r => setTimeout(r, 80));
                try {
                    const rpcUrl = yield getDefVal(`${chain.toLowerCase()}_api`);
                    let client = chain === 'HIVE' ? hive : chain === 'BLURT' ? blurt : steem;
                    client.api.setOptions({ url: rpcUrl });
                    const [accs] = yield Promise.all([client.api.getAccountsAsync([username])]);
                    if (!accs || !accs[0]) {
                        item.status = 'skipped';
                        item.message = 'Account not found';
                        continue;
                    }
                    const acc = accs[0];
                    let rewardToken = '', rewardStable = '', rewardVests = '';
                    if (chain === 'STEEM') {
                        rewardToken = acc.reward_steem_balance || '0 STEEM';
                        rewardStable = acc.reward_sbd_balance || '0 SBD';
                        rewardVests = acc.reward_vesting_balance || '0 VESTS';
                    }
                    else if (chain === 'HIVE') {
                        rewardToken = acc.reward_hive_balance || '0 HIVE';
                        rewardStable = acc.reward_hbd_balance || '0 HBD';
                        rewardVests = acc.reward_vesting_balance || '0 VESTS';
                    }
                    else {
                        rewardToken = acc.reward_blurt_balance || '0 BLURT';
                        rewardVests = acc.reward_vesting_balance || '0 VESTS';
                    }
                    const hasClaim = parseFloat(rewardToken) > 0 || parseFloat(rewardStable) > 0 || parseFloat(rewardVests) > 0;
                    item.claimable = hasClaim;
                    if (!hasClaim) {
                        item.status = 'skipped';
                        item.message = 'Nothing to claim';
                        continue;
                    }
                    item.status = 'claiming';
                    const key = chain === 'HIVE' ? (_a = account.keys) === null || _a === void 0 ? void 0 : _a.postinghive :
                        chain === 'BLURT' ? (_b = account.keys) === null || _b === void 0 ? void 0 : _b.postingblurt :
                            (_c = account.keys) === null || _c === void 0 ? void 0 : _c.posting;
                    if (!key) {
                        item.status = 'error';
                        item.message = 'Missing key';
                        continue;
                    }
                    if (chain === 'BLURT') {
                        yield new Promise((resolve, reject) => {
                            client.broadcast.claimRewardBalance(key, username, rewardToken, rewardVests, (err, res) => err ? reject(err) : resolve(res));
                        });
                    }
                    else {
                        yield new Promise((resolve, reject) => {
                            client.broadcast.claimRewardBalance(key, username, rewardToken, rewardStable, rewardVests, (err, res) => err ? reject(err) : resolve(res));
                        });
                    }
                    let claimed = [];
                    if (parseFloat(rewardToken) > 0)
                        claimed.push(rewardToken);
                    if (parseFloat(rewardStable) > 0)
                        claimed.push(rewardStable);
                    if (parseFloat(rewardVests) > 0)
                        claimed.push(rewardVests);
                    item.status = 'done';
                    item.message = claimed.join(' • ');
                }
                catch (err) {
                    item.status = 'error';
                    item.message = err.message || 'Claim failed';
                }
            }
        }
        setIsBulkClaiming(false);
        setClaimAllUsers(false);
        setClaimAllChains(false);
    });
    const stopClaiming = () => {
        stopFlagRef.current = true;
    };
    const closeBulkModal = () => {
        setShowBulkClaimModal(false);
        setBulkClaimItems([]);
        stopFlagRef.current = false;
        refresh();
    };
    const isClaimDisabled = (!canClaim && !claimAllUsers && !claimAllChains);
    return (React.createElement("div", { className: "top-bar" },
        React.createElement("table", { style: { borderCollapse: 'collapse' } },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { style: { verticalAlign: 'middle', paddingRight: '2px' } },
                        React.createElement(SVGIcon, { icon: SVGIcons.MENU_BUTTON, onClick: () => navigateTo(Screen.SETTINGS_MAIN_PAGE), className: "button settings-button" })),
                    React.createElement("td", { style: { verticalAlign: 'middle', paddingRight: '2px' } },
                        React.createElement(SVGIcon, { className: `logo ${rotateLogo ? 'rotate' : ''}`, icon: SVGIcons.TOP_BAR_KEYCHAIN_LOGO, onClick: refresh })),
                    React.createElement("td", { style: { verticalAlign: 'middle', paddingRight: '2px' } },
                        React.createElement(SVGIcon, { icon: SVGIcons.WALLET_HISTORY_BUTTON, onClick: () => navigateTo(Screen.HISTORY_PAGE), className: "button history-button", hoverable: true })),
                    React.createElement("td", { style: { verticalAlign: 'middle', paddingLeft: '2px' } },
                        React.createElement("div", { style: {
                                background: 'rgba(255,255,255,0.05)',
                                border: '1px solid #555',
                                borderRadius: '3px',
                                padding: '2px',
                                width: '50px',
                                height: '45px',
                                display: 'flex',
                                flexDirection: 'column'
                            } },
                            React.createElement("button", { onClick: claimReward, disabled: isClaimDisabled, style: {
                                    background: isClaimDisabled ? '#555' : 'linear-gradient(135deg, #ff4757, #ff6b6b)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '2px 8px',
                                    borderRadius: '2px',
                                    fontWeight: 'bold',
                                    fontSize: '12px',
                                    cursor: isClaimDisabled ? 'not-allowed' : 'pointer',
                                    width: '100%',
                                    lineHeight: '1.2',
                                    marginBottom: '1px'
                                }, title: "Claim Rewards" }, "Claim"),
                            React.createElement("div", { style: {
                                    display: 'flex',
                                    gap: '4px',
                                    marginTop: '1px',
                                    flex: 1
                                } },
                                React.createElement("div", { style: { flex: 1, textAlign: 'center', lineHeight: '1' } },
                                    React.createElement("label", { style: { fontSize: '8px', color: '#ccc', display: 'block', marginBottom: '0px' } }, "IDs"),
                                    React.createElement("input", { type: "checkbox", checked: claimAllUsers, onChange: (e) => setClaimAllUsers(e.target.checked), style: { transform: 'scale(0.9)', marginTop: '0px' } })),
                                React.createElement("div", { style: { flex: 1, textAlign: 'center', lineHeight: '1' } },
                                    React.createElement("label", { style: { fontSize: '8px', color: '#ccc', display: 'block', marginBottom: '0px' } }, "Chains"),
                                    React.createElement("input", { type: "checkbox", checked: claimAllChains, onChange: (e) => setClaimAllChains(e.target.checked), style: { transform: 'scale(0.9)', marginTop: '0px' } })))))))),
        React.createElement("div", { className: "spacer" }),
        React.createElement("div", { style: {
                position: 'relative',
                zIndex: 1000 // Permette alla dropdown di essere visibile sopra altri elementi
            } },
            React.createElement("style", null, `
          /* OVERRIDE FORZATO SOLO PER QUESTO CONTENITORE */
          .select-account-section .react-dropdown-select-dropdown {
            height: 600px !important;
            max-height: 600px !important;
            min-height: 600px !important;
            overflow-y: auto !important;
          }
          .select-account-section .custom-select-dropdown {
            height: 600px !important;
            max-height: 600px !important;
            overflow-y: auto !important;
          }
          .select-account-section .select-account-item {
            margin-bottom: 0px !important;
            padding: 4px 6px !important;
          }
        `),
            React.createElement(SelectAccountSectionComponent, { isOnMain: true })),
        showBulkClaimModal && (React.createElement("div", { style: {
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 10000,
                display: 'flex', alignItems: 'center', justifyContent: 'center'
            } },
            React.createElement("div", { style: {
                    background: '#161b22', color: '#e6edf3', padding: '24px', borderRadius: '12px',
                    width: '90%', maxWidth: '620px', maxHeight: '85vh', overflowY: 'auto'
                } },
                React.createElement("h3", null, "Claim Rewards"),
                React.createElement("div", { style: { margin: '20px 0', maxHeight: '60vh', overflowY: 'auto' } }, bulkClaimItems.length === 0 ? (React.createElement("p", null, "Starting...")) : (Array.from(new Set(bulkClaimItems.map(i => i.username))).map(username => {
                    const userItems = bulkClaimItems.filter(i => i.username === username);
                    return (React.createElement("div", { key: username, style: { marginBottom: '18px' } },
                        React.createElement("strong", { style: { fontSize: '1.1em' } },
                            "@",
                            username),
                        React.createElement("div", { style: { marginTop: '6px', marginLeft: '12px' } }, userItems.map((item, idx) => (React.createElement("div", { key: idx, style: {
                                padding: '6px 0',
                                display: 'flex',
                                justifyContent: 'space-between',
                                borderBottom: '1px solid #333'
                            } },
                            React.createElement("span", null,
                                React.createElement("strong", null, item.chain)),
                            React.createElement("span", { style: {
                                    color: item.status === 'done' ? '#50fa7b' :
                                        item.status === 'error' ? '#ff6b6b' : '#aaa'
                                } }, item.message || (item.status === 'checking' ? 'Checking...' :
                                item.status === 'claiming' ? 'Claiming...' :
                                    item.status === 'skipped' ? 'Nothing to claim' : ''))))))));
                }))),
                React.createElement("div", { style: { display: 'flex', gap: '12px', marginTop: '20px' } }, isBulkClaiming ? (React.createElement("button", { onClick: stopClaiming, style: {
                        flex: 1, padding: '14px', background: '#ff4757', color: 'white',
                        border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '16px'
                    } }, "STOP")) : (React.createElement("button", { onClick: closeBulkModal, style: {
                        flex: 1, padding: '14px', background: '#3fb950', color: 'white',
                        border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '16px'
                    } }, "OK"))))))));
};
const mapStateToProps = (state) => ({
    activeAccount: state.steem.activeAccount,
    accounts: state.steem.accounts,
});
const connector = connect(mapStateToProps, {
    navigateTo,
    addToLoadingList,
    removeFromLoadingList,
    setErrorMessage,
    setSuccessMessage,
});
export const TopBarComponent = connector(TopBar);
